import { RootState } from "chat/imports/state";

export const chatGiftAnimationSelectors = {
  getGiftToPlay: (state: RootState) => state.chatGiftAnimation.giftsToPlay?.[0],
};
